// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-btn.v-btn--disabled.nohover .v-icon[data-v-4d232f9a]{color:#000!important;opacity:1}.v-btn.v-btn--disabled.nohover.theme--dark .v-icon[data-v-4d232f9a]{color:#fff!important;opacity:1}", ""]);
// Exports
module.exports = exports;
